module.exports = __webpack_public_path__ + "static/media/Analyze-and-Aware.05fcf77a.jpg";